import axios from 'axios';
import API from '../api';

export const PackagesModule = {
  state: {
    error: '',
    errored: false,
    packages: [],
    requesting: false
  },

  actions: {
    getPackages ({ commit }) {
      return new Promise(async (resolve, reject) => {
        commit('PACKAGE_REQ_STARTED');
        return axios
          .get(`${ API.BASE_URL }${ API.PACKAGES }`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit('PACKAGE_GET_SUCCESS', response.data);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit('PACKAGE_REQ_FAILED', error);
            reject(error);
          });
      });
    },

    createPackage ({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        commit('PACKAGE_REQ_STARTED');
        return axios
          .post(`${ API.BASE_URL }${ API.PACKAGES }`, payload, API.RequestHeaders())
          .then(response => {
            if (response.status === 201) {
              commit('PACKAGE_CREATE_SUCCESS', response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit('PACKAGE_REQ_FAILED', error);
            reject(error);
          });
      });
    },

    updatePackage ({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        const package_id = payload.id;
        delete payload.id;
        commit('PACKAGE_REQ_STARTED');
        return axios
          .put(`${ API.BASE_URL }${ API.PACKAGES }/${ package_id }`, payload, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit('PACKAGE_UPDATE_SUCCESS', response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit('PACKAGE_REQ_FAILED', error);
            reject(error);
          });
      });
    },

    deletePackage ({ commit }, id) {
      return new Promise(async (resolve, reject) => {
        commit('PACKAGE_REQ_STARTED');
        return axios
          .delete(`${ API.BASE_URL }${ API.PACKAGES }/${ id }`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit('PACKAGE_DELETE_SUCCESS', id);
              resolve();
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit('PACKAGE_REQ_FAILED', error);
            reject(error);
          });
      });
    }
  },

  mutations: {
    PACKAGE_REQ_STARTED (state) {
      state.requesting = true;
    },

    PACKAGE_REQ_FAILED (state, error) {
      state.requesting = false;
      state.errored = true;
      state.error = error.message;
    },

    PACKAGE_GET_SUCCESS (state, payload) {
      state.packages = payload;
      state.requesting = false;
    },

    PACKAGE_CREATE_SUCCESS (state, payload) {
      state.packages.push(payload);
      state.requesting = false;
    },

    PACKAGE_UPDATE_SUCCESS (state, payload) {
      const index = state.packages
        .map(_package => _package.id)
        .indexOf(payload.id);

      state.packages[index] = {
        ...state.packages[index],
        ...payload
      };
      state.requesting = false;
    },

    PACKAGE_DELETE_SUCCESS (state, id) {
      const deleted = state.packages
        .find(_package => _package.id === id);

      const index = state.packages.indexOf(deleted);
      state.packages.splice(index, 1);
      state.requesting = false;
    }
  }
};